import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HeroP from './pages/HeroPage';
import TempP from './pages/TempPage';
import OfferP from './pages/OfferPage';
import AboutP from './pages/AboutPage';
import PolicyP from './pages/PolicyPage';
import ThankP from './pages/ThankPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" exact element={<HeroP />} />
          <Route path="/templates" element={<TempP />} />
          <Route path="/signup" element={<OfferP />} />
          <Route path="/about" element={<AboutP />} />
          <Route path="/policy" element={<PolicyP />} />
          <Route path="/complete" element={<ThankP />} />
          {/* Add other routes here */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
